import Head from 'expo-router/head';
import { ScrollView } from 'react-native';
import { getTokenValue, YStack } from 'tamagui';

import APEmptySection from '@/components/APEmptySection';
import PSText from '@/components/ui/PSText';

export default function APEmptySectionPreview() {
  return (
    <>
      <Head>
        <title>APEmptySection · Putting Scene</title>
      </Head>
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: getTokenValue('$color.background', 'color'),
        }}
      >
        <YStack gap="$xs" p="$lg">
          <PSText.Body3 color="$textDarkMuted">
            On home&apos;s dark Access Pass band
          </PSText.Body3>
          <YStack bg="$color.brandDark" p="$space.lg" rounded="$base">
            <APEmptySection />
          </YStack>
        </YStack>
      </ScrollView>
    </>
  );
}
